/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Payor/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'



/** @type {import('Simple/types.js').View} */
export default function Payor({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Ledger/New/Content/Receivables/Content/Transactions/Content/Content/Transaction/EntityType/Payment/Payor"
  
}) {
let entryAppliedPaymentPaymentAccountValueData = fromData.useDataFormat({ viewPath,
context: 'entry',
path: 'applied_payment.payment.account',
format: fromHelpers.getPayorName,
})
  return (<React.Fragment
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 data="entry.applied_payment.payment.account"
 format="helpers.js getPayorName"
 text={entryAppliedPaymentPaymentAccountValueData}
 weight="semibold"
/>
{children}
</React.Fragment>)
}